import type { FunctionComponent, ReactNode } from 'react';

import { InChatClarifyCard } from '~/ui/domain/chat/InChatClarifyCard';
import type { ClarifyOption } from '~/ui/domain/chat/types';

import type { QuestionnaireQuestion } from '../../../data-contract/chat';
import { QuestionLabel } from './questionnaire-flow';

const toClarifyOptions = (question: QuestionnaireQuestion): ClarifyOption[] =>
    [...question.options]
        .sort((a, b) => (a.recommended === b.recommended ? 0 : a.recommended === true ? -1 : 1))
        .map((option) => ({
            headline: option.label,
            subline: option.additionalInformation ?? undefined,
            recommended: option.recommended ?? undefined,
        }));

export const QuestionOptionsInput: FunctionComponent<{
    readonly headerAction?: ReactNode;
    readonly question: QuestionnaireQuestion;
    readonly onSelect: (value: string) => void;
    readonly selectedAnswer?: string;
}> = ({ headerAction, question, onSelect, selectedAnswer }) => (
    <InChatClarifyCard
        onSelect={onSelect}
        allowCustomInput={question.allowCustomInput === true}
        headerContent={<QuestionLabel label={question.label} />}
        headerAction={headerAction}
        label=""
        options={toClarifyOptions(question)}
        selectedValue={selectedAnswer}
    />
);
